import * as React from "react";
import PropTypes from "prop-types";
const SvgSportsKitesurfNormalLarge = React.forwardRef(
  ({ color = "currentColor", size = 48, title, titleId, ...props }, ref) => (
    <svg
      fill={color}
      viewBox="0 0 48 48"
      xmlns="http://www.w3.org/2000/svg"
      ref={ref}
      width={size}
      height={size}
      aria-labelledby={titleId}
      {...props}
    >
      {title ? <title id={titleId}>{title}</title> : null}
      <path
        d="M41.64 32.239l-4.647-18.95C37.1 9.596 36 6.105 33.448 3.552 30.304.408 25.755-.526 21.133.271c-4.627.797-9.469 3.338-13.497 7.366C3.61 11.664 1.068 16.507.27 21.133c-.797 4.623.138 9.171 3.282 12.315 2.61 2.611 6.204 3.703 9.99 3.535.06-.002.12-.008.178-.018l18.548 4.646-3.329 3.329 2.122 2.12 16-16-2.122-2.12zM9.758 9.758c2.155-2.155 4.538-3.808 6.943-4.94l3.051 8.39c-1.256.831-2.467 1.817-3.597 2.947s-2.116 2.34-2.948 3.597l-8.389-3.05c1.132-2.405 2.785-4.79 4.94-6.944zM22.4 11.712l-2.9-7.975a17.889 17.889 0 012.143-.51c3.952-.681 7.414.177 9.683 2.446 1.341 1.341 2.187 3.09 2.517 5.113-2.206-.878-4.738-.991-7.263-.48-1.39.28-2.797.753-4.18 1.406zm4.775 1.534c2.776-.562 5.231-.15 6.99 1.106l4.994 20.367L38 35.88 27.296 25.174 23.43 14.546a15.485 15.485 0 013.744-1.3zm7.566 25.892L14.24 34.003c-1.168-1.746-1.54-4.136-.995-6.827a15.485 15.485 0 011.3-3.745l10.63 3.865L35.879 38zM18.276 18.276c.81-.81 1.661-1.53 2.535-2.156l2.68 7.372-7.37-2.68a20.405 20.405 0 012.155-2.536zM3.737 19.501l7.975 2.9a18.343 18.343 0 00-1.407 4.18c-.51 2.524-.397 5.056.48 7.262-2.022-.33-3.771-1.176-5.112-2.516-2.27-2.27-3.128-5.732-2.446-9.684.121-.705.291-1.42.51-2.142z"
        fill=""
      />
    </svg>
  )
);
SvgSportsKitesurfNormalLarge.propTypes = {
  color: PropTypes.string,
  size: PropTypes.oneOfType([PropTypes.string, PropTypes.number]),
  title: PropTypes.string,
  titleId: PropTypes.string,
};
export default SvgSportsKitesurfNormalLarge;
